// Same Rolldown 1.x CJS interop issue as react-datetime: UMD bundle sets __esModule
// via Object.defineProperty but Rolldown doesn't unwrap module.exports.default.
// Import via the dist subpath (bypasses alias) and re-export as proper ESM.
//
// `defaultModules.set` expects the full ModuleExport shape { default, position, defaults },
// so we re-export all three named exports. Callers use
// `import * as PNotifyMobile from '@pnotify/mobile'` to get the namespace.
import _mod from '@pnotify/mobile/dist/PNotifyMobile.js'
const mod = _mod as any
export default mod.default ?? mod
export const defaults: object = mod.defaults ?? {}
export const position: string = mod.position ?? 'PrependContainer'
